import React from 'react';
import Select from 'react-select';

const TrainingSort = ({ resultSort, setResultSort }) => {
  const sortOptions = [
    {
      label: I18n.t('training_overview_page.index.sort.sort_label'),
      value: '',
    },
    {
      value: 1,
      label: I18n.t('training_overview_page.index.sort.sort_by_date_up'),
    },
    {
      value: 2,
      label: I18n.t('training_overview_page.index.sort.sort_by_date_down'),
    },
    {
      value: 3,
      label: I18n.t('training_overview_page.index.sort.sort_by_titel_up'),
    },
    {
      value: 4,
      label: I18n.t('training_overview_page.index.sort.sort_by_titel_down'),
    },
  ];

  const isActive = (filter) => filter > 0 && 'is-set';

  return (
    <div className="training-sort-widget">
      <div className="react-select-widget">
        <Select
          classNamePrefix="react-select"
          className={'react-select-container ' + isActive(resultSort)}
          options={sortOptions}
          onChange={(selectedOption) => setResultSort(selectedOption.value)}
          value={sortOptions.find((option) => option.value === resultSort)}
          aria-label={I18n.t(
            'training_overview_page.index.sort.sort_arialabel'
          )}
        />
      </div>
    </div>
  );
};

export default TrainingSort;
